import { put } from 'redux-saga/effects'
import axios from '../../axios-conf'
import uris from '../../uris'
import {
  scoreLoadSuccess,
  scoreLoadFailure,
  addNotification,
  scoreSaveSuccess,
  scoreSaveFailure
} from '../actions'
import { uiConstants } from '../../constants'
import { uiHelper } from '../../helpers'

export function* scoreLoadSaga(action) {
  try {
    const result = yield axios.get(
      `${uris.scoreBaseUrl}${action.payload.customer}?r=${action.payload.roomName}`
    )
    yield put(scoreLoadSuccess(result.data))
  } catch (error) {
    yield put(scoreLoadFailure(error))
    yield put(
      addNotification(
        uiHelper.errorMessage(error),
        uiConstants.notification.error
      )
    )
  }
}

export function* scoreSaveSaga(action) {
  try {
    const c = action.payload.c
    delete action.payload.c

    const result = yield axios.post(`${uris.scoreBaseUrl}${c}`, action.payload)

    yield put(scoreSaveSuccess(result.data))
  } catch (error) {
    yield put(scoreSaveFailure(error))
    yield put(
      addNotification(
        uiHelper.errorMessage(error),
        uiConstants.notification.error
      )
    )
  }
}
